import styled from "styled-components"

export const CommonWrapper = styled.div`
  /* width: 100%; */
  /* padding-left: 0.5em; */
  box-sizing: border-box;
`
